import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { reduxForm, FieldArray } from "redux-form";
import { IntlFieldGroup } from "../../../../common/form";
import { FormattedMessage } from "react-intl";

import RenderCoverageList from "./RenderCoverageList";

import validationUtils from "../../../../../utils/ValidationUtils";
import { COVERAGE_GROUPS_VALIDATION_RULES } from "./coverageGroupsValidationRules";

class BasicCoverageGroupFields extends React.Component {
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  renderFieldArray() {
    return (
      <div className="form-group">
        <label htmlFor="withdrawalClientCoverages" className="control-label">
          <FormattedMessage id="withdrawalConfiguration.form.guarantees" />
        </label>
        <div className="input-wrapper">
          <FieldArray
            name="withdrawalClientCoverages"
            withdrawalClientCoverages={
              this.props.initialValues.withdrawalClientCoverages
            }
            component={RenderCoverageList}
            props={{
              onChange: () => this.props.touch("withdrawalClientCoverages"),
            }}
            //Changing fields in a fieldArray does not 'touch()' the fieldArray itself
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <IntlFieldGroup
          key="name"
          field="name"
          labelKey={`withdrawalConfiguration.form.name`}
          localizations={this.props.initialValues.localizations}
        />

        {this.renderFieldArray()}

        <IntlFieldGroup
          key="emailMessage"
          field="emailMessage"
          className="email-message"
          type="textarea"
          labelKey={`withdrawalConfiguration.form.emailMessage`}
          localizations={this.props.initialValues.localizations}
        />
      </form>
    );
  }
}

BasicCoverageGroupFields.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  touch: PropTypes.func,
  validation: PropTypes.object,
};

BasicCoverageGroupFields.defaultProps = {
  scene: "",
};

BasicCoverageGroupFields.childContextTypes = {
  scene: PropTypes.string,
};

export default connect(null, null, null, { withRef: true })(
  reduxForm({
    form: "guaranteeGroups",
    validate: (values) =>
      validationUtils.validate(values, COVERAGE_GROUPS_VALIDATION_RULES),
  })(BasicCoverageGroupFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/BasicCoverageGroupFields.js